import { useState,useEffect } from "react";
import axios from "axios";
import { useSelector } from "react-redux";
import { webUrlNode } from "../../../constants/appInfo";

export default function HomeworkRow({
  homework,
  index,
  batchId,
  checked,
  linkedMap,
  setLinkedMap
}){

  const AppToken = useSelector((s)=>s?.app?.app?.AppToken);
  const coursePostId = useSelector((s)=>s?.course?.course?.postId);

  const [releaseAt,setReleaseAt] = useState("");
  const [dueAt,setDueAt] = useState("");

  useEffect(()=>{

    if(linkedMap[homework.id]){

      const data = linkedMap[homework.id];

      setReleaseAt(data.releaseAt || "");
      setDueAt(data.dueAt || "");

    }

  },[linkedMap,homework.id]);


  async function toggle(){

    const existing = linkedMap[homework.id];

    try{

      // DELETE
      if(existing){

        await axios.delete(
          `${webUrlNode}/api/batches/homework/${existing.id}`,
          {
            params:{appToken:AppToken}
          }
        );

        setLinkedMap(prev=>{
          const copy={...prev};
          delete copy[homework.id];
          return copy;
        });

      }

      // ATTACH
      else{

        const res = await axios.post(
          `${webUrlNode}/api/batches/${batchId}/homework`,
          {
            coursePostId,
            homeworkId:homework.id,
            releaseAt,
            dueAt,
            displayOrder:1
          },
          {
            params:{appToken:AppToken}
          }
        );

        const newId = res.data.id;

        setLinkedMap(prev=>({
          ...prev,
          [homework.id]:{
            id:newId,
            releaseAt,
            dueAt
          }
        }));

      }

    }
    catch(e){
      alert("Failed to update");
    }

  }


  return(

    <div
      style={{
        background:"#f9f9f9",
        padding:"15px",
        borderRadius:6,
        marginBottom:10,
        display:"flex",
        justifyContent:"space-between"
      }}
    >

      <div>

        <div style={{fontWeight:600}}>
          {index+1}. {homework.title}
        </div>
 <div style={{ display:"flex",
        justifyContent:"space-between", gap:"10px",flexWrap:"wrap"}}>
        <div style={{ display:"flex",
        justifyContent:"center", alignItems:"center",gap:"10px"}}>
      <div style={{fontSize:12,color:"#666"}}>    Release At: </div> 

            <input  style={{fontSize:"20px",color:"#222222",background:"rgba(144, 202, 249,0.1)",border:"0px"
          ,borderRadius:"15px",cursor:"pointer",height:"35px"}}
              type="date"
              value={releaseAt}
              onChange={(e)=>setReleaseAt(e.target.value)}
            />

          </div>


        <div style={{ display:"flex", justifyContent:"center", alignItems:"center",gap:"10px"}}>
          <div style={{fontSize:12,color:"#666"}}>Due At:</div> 
   

            <input  style={{fontSize:"20px",color:"#222222",background:"rgba(144, 202, 249,0.1)",border:"0px"
          ,borderRadius:"15px",cursor:"pointer",height:"35px"}}
              type="date"
              value={dueAt}
              onChange={(e)=>{setDueAt(e.target.value)}}
            />

          </div>

        </div>


      
      </div>

<label style={{marginTop:"30px"}} className={"checkbox-outer  "}>
        <input   className="input-textbox"
          type="checkbox"
           onClick={toggle}
        checked={checked}
        readOnly
       
        /> <span className={"square"}></span>

                                                                         </label>

    </div>

  );

}